// PRODUCCION
// export const TIPOS_SOL = 368;
// export const TIPOS_SERV = 369;
// export const GENERO = 69;
// export const ORIENTACION_SEXUAL = 230;
// export const ESTADO_CIVIL = 249;
// export const GRUPO_PRIORIZADO = 387;
// export const MODALIDAD_ASESORIA = 370;
// export const EPS = 267;
// export const TIPO_REL = 371;
// export const OTRO_GRUPO = 35340;
// export const DEPARTAMENTOS = 7;
// export const CIUDADES = 8;
// export const ESTADOS_BIENESTAR = 372;
// export const SESIONES_BIENESTAR = 357; 
// export const TIPOS_ASESORIA = 373;
// export const TIPOS_FORMAS_ASESORIAS = 375;
// export const PARENTESCOS_BIENESTAR = 374;
// export const CARRERAS_CUC = 5;
// export const PROTECCION_DATOS_BIENESTAR = 376;
// export const CONSENTIMIENTO_GENERAL = 377;
// export const CONSENTIMIENTO_CRISIS = 378;
// export const TEXTOS_LEGALES = 379;
// export const FICHA_SEGUIMIENTO_BIENESTAR = 380;
// export const ENTIDADES_EXTERNAS_BIENESTAR = 381;
// export const INTERESADO_BIENESTAR = 382;
// export const INTERESADO_BIENESTAR_ROL = 383;
// export const INDENTIDAD_GENERO_BIENESTAR = 363;
// export const FASES_BIENESTAR = 384;
// export const MODULOS_FASES_BIENESTAR = 385;
// export const OTRA_ORIENTACION_BIENESTAR = 35263;
// export const OTRA_IDENTIDAD_GENERO_BIENESTAR = 35192;
// export const CORREO_COORDINADOR_BIENESTAR = 13;
// export const PRIORIDAD_BIENESTAR = 386;
// export const FACTORES_RIESGO_BIENESTAR = 394;
// export const POBLACIONES_BIENESTAR = 395;

// TEST
export const TIPOS_SOL = 368;
export const TIPOS_SERV = 369;
export const GENERO = 69;
export const ORIENTACION_SEXUAL = 230;
export const ESTADO_CIVIL = 249;
export const GRUPO_PRIORIZADO = 387;
export const MODALIDAD_ASESORIA = 370;
export const EPS = 267;
export const TIPO_REL = 371;
export const OTRO_GRUPO = 35340;
export const DEPARTAMENTOS = 7;
export const CIUDADES = 8;
export const ESTADOS_BIENESTAR = 372;
export const SESIONES_BIENESTAR = 357; 
export const TIPOS_ASESORIA = 373;
export const TIPOS_FORMAS_ASESORIAS = 375;
export const PARENTESCOS_BIENESTAR = 374;
export const CARRERAS_CUC = 5;
export const PROTECCION_DATOS_BIENESTAR = 376;
export const CONSENTIMIENTO_GENERAL = 377;
export const CONSENTIMIENTO_CRISIS = 378;
export const TEXTOS_LEGALES = 379;
export const FICHA_SEGUIMIENTO_BIENESTAR = 380;
export const ENTIDADES_EXTERNAS_BIENESTAR = 381;
export const INTERESADO_BIENESTAR = 382;
export const INTERESADO_BIENESTAR_ROL = 383;
export const INDENTIDAD_GENERO_BIENESTAR = 363;
export const FASES_BIENESTAR = 384;
export const MODULOS_FASES_BIENESTAR = 385;
export const OTRA_ORIENTACION_BIENESTAR = 35263;
export const OTRA_IDENTIDAD_GENERO_BIENESTAR = 35192;
export const CORREO_COORDINADOR_BIENESTAR = 13;
export const PRIORIDAD_BIENESTAR = 386;
export const FACTORES_RIESGO_BIENESTAR = 395;
export const POBLACIONES_BIENESTAR = 399;

// LOCAL
// export const TIPOS_SOL = 3215;
// export const TIPOS_SERV = 3216;
// export const GENERO = 67;
// export const ORIENTACION_SEXUAL = 3221;
// export const ESTADO_CIVIL = 3222;
// export const GRUPO_PRIORIZADO = 5242;
// export const MODALIDAD_ASESORIA = 3217;
// export const EPS = 3223;
// export const TIPO_REL = 3218;
// export const OTRO_GRUPO = 5835;
// export const DEPARTAMENTOS = 7;
// export const CIUDADES = 8;
// export const CARRERAS_CUC = 5;
// export const ESTADOS_BIENESTAR = 3219;
// export const SESIONES_BIENESTAR = 3224;
// export const FASES_BIENESTAR = 3232;
// export const MODULOS_FASES_BIENESTAR = 3233;
// export const TIPOS_ASESORIA = 3225;
// export const TIPOS_FORMAS_ASESORIAS = 3227;
// export const PARENTESCOS_BIENESTAR = 3226;
// export const PROTECCION_DATOS_BIENESTAR = 3229;
// export const CONSENTIMIENTO_GENERAL = 3230;
// export const CONSENTIMIENTO_CRISIS = 3231;
// export const TEXTOS_LEGALES = 3234;
// export const FICHA_SEGUIMIENTO_BIENESTAR = 3235;
// export const ENTIDADES_EXTERNAS_BIENESTAR = 3236;
// export const INTERESADO_BIENESTAR = 3237;
// export const INTERESADO_BIENESTAR_ROL = 4235;
// export const INDENTIDAD_GENERO_BIENESTAR = 4236;
// export const OTRA_ORIENTACION_BIENESTAR = 5827;
// export const OTRA_IDENTIDAD_GENERO_BIENESTAR = 10914;
// export const CORREO_COORDINADOR_BIENESTAR = 13;
// export const PRIORIDAD_BIENESTAR = 5241;
// export const FACTORES_RIESGO_BIENESTAR = 5243;
// export const POBLACIONES_BIENESTAR = 5245;

// CODIGOS PERFILES BIENESTAR
export const PERFIL_ADMIN = 'Per_Adm';
export const PERFIL_ADMIN_BIENESTAR = 'Per_Bien_Gest';
export const PERFIL_DOCENTE = 'Per_Doc';
export const PERFIL_PSICOLOGO = 'Per_Bien_Ps';

// Cuenta compartida con la que entran los padres y acudientes a remitir.
export const PERFIL_ACUDIENTE = 'Per_Acu';
export const PERFILES_ESTUDIANTE = [
  'Per_Nor',
  'Per_Ment',
  'Per_Est_Pos',
  'Per_Est_Hep',
  'Per_Est',
];

// CODIGOS DOCUMENTOS FICHAS
export const COD_CRISIS = "bien_cris";
export const COD_COMUNICATE = "bien_com";
export const COD_APRENDER = "bien_apr";
export const COD_CULTURA_C = "bien_diver";
export const COD_EQUIDAD_G = "bien_equi";
export const COD_SOCIOEMOCIONAL = "bien_pas";
export const COD_FICHA_UNICA = "ficha_unica";

// CODIGOS TIPOS DE SOLICITUDES
export const COD_SOL_PASPE = "paspe_bienestar";
export const COD_SOL_REM = "rem_bienestar";

// PERMISOS
export const PERMISO_TIPO_SOLICITUD = 57;
export const PERMISO_TIPO_SERVICIO = 58;
export const PERMISO_ESTADO = 59;
export const PERMISO_POBLACION = 60;

// CODIGOS ESTADOS DE SOLICITUDES
export const COD_ESTADO_SOLICITADO = "Est_Bien_Sol";
export const COD_ESTADO_SOL_REMISION = "Est_Bien_Rem";
export const COD_ESTADO_GESTION = "Est_Bien_Ges";
export const COD_ESTADO_AGENDAMIENTO = "Est_Bien_Age";
export const COD_ESTADO_ATENDIDO = "Est_Bien_Ate";
export const COD_ESTADO_CIERRE = "Est_Bien_Cie";
export const COD_ESTADO_RECHAZO = "Est_Bien_Rec";
export const COD_ESTADO_TODOS = "Tod_Bien";

// CODIGOS NIVEL DE PRIORIDAD (REMISIONES)
// Una remision con motivo de riesgo alto se marca URGENTE automaticamente.
export const COD_PRIORIDAD_URGENTE = "prio_urgente";

// CODIGOS NOTIFICACIONES BIENESTAR
export const COD_AVISO_DISENTIMIENTO = "avi_bien_disen";

// NIVELES DE FACTOR DE RIESGO
// El nivel viaja en el campo valora del valor de la generica FACTORES_RIESGO_BIENESTAR.
export const NIVEL_RIESGO_ALTO = 'fact_alto';
export const NIVEL_RIESGO_MEDIO = 'fact_medio';
export const NIVEL_RIESGO_BAJO = 'fact_bajo';

// Peso para ordenar: primero lo mas urgente. Las solicitudes viejas sin factor
// quedan de ultimas.
export const ORDEN_NIVEL_RIESGO = {
  [NIVEL_RIESGO_ALTO]: 1,
  [NIVEL_RIESGO_MEDIO]: 2,
  [NIVEL_RIESGO_BAJO]: 3,
};
export const ORDEN_RIESGO_SIN_FACTOR = 4;

export const COLORES_RIESGO = {
  [NIVEL_RIESGO_ALTO]: { backgroundColor: '#c62828', color: '#FFF', etiqueta: 'RIESGO ALTO' },
  [NIVEL_RIESGO_MEDIO]: { backgroundColor: '#ef6c00', color: '#FFF', etiqueta: 'RIESGO MEDIO' },
  [NIVEL_RIESGO_BAJO]: { backgroundColor: '#2e7d32', color: '#FFF', etiqueta: 'RIESGO BAJO' },
};

export const COLORES_ESTADO = {
  'Est_Bien_Sol': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
  'Est_Bien_Ges': { 'backgroundColor': '#ae74ff', 'color': '#FFF' },
  'Est_Bien_Age': { 'backgroundColor': '#fcd116', 'color': '#FFF' },
  'Est_Bien_Ate': { 'backgroundColor': '#0d7fd9', 'color': '#FFF' },
  'Est_Bien_Cie': { 'backgroundColor': '#078030', 'color': '#FFF' },
  'Est_Bien_Rec': { 'backgroundColor': '#933b27', 'color': '#FFF' },
  'Tod_Bien': { backgroundColor: '#1276c2ff', color: '#FFF' }
}

